import React from 'react';
import Nav_menu from "./nav_menu";

const Nav = ({ totalMonthPrice }) => {
    return (
        <>
            <Nav_menu />
            <header>
                <div className="container">
                    <a href="/" className="logo">
                        <img src="https://otlob.nagwa.com/Content/images/logo.svg" alt="" />
                    </a>
                    <p>اجمالي طلبات الشهر: <span>{totalMonthPrice}</span> ج.م.</p>
                </div>
            </header>
        </>
    );
};

export default Nav;